<script lang="ts">
  import { inview } from "../actions";
  let {
    label,
    title,
    lead = "",
    align = "left",
  }: { label: string; title: string; lead?: string; align?: "left" | "center" } =
    $props();
</script>

<div class="head" class:center={align === "center"}>
  <p class="kicker reveal" use:inview>{label}</p>
  <h2 class="reveal" use:inview={{ delay: 90 }}>{title}</h2>
  {#if lead}
    <p class="lead reveal" use:inview={{ delay: 170 }}>{lead}</p>
  {/if}
</div>

<style>
  .head {
    max-width: 62ch;
  }
  .head.center {
    margin-inline: auto;
    text-align: center;
  }
  .head.center .kicker {
    justify-content: center;
  }
  h2 {
    font-size: var(--fs-h2);
    margin-top: 1.1rem;
  }
  .lead {
    margin-top: 1.4rem;
    font-size: var(--fs-lead);
    color: var(--ink-soft);
    line-height: 1.85;
  }
</style>
